import type { SupportedAudioEmbedTypes, EmbedMeta } from './types'

// Mimetype mapping taken from https://developer.mozilla.org/en-US/docs/Web/HTTP/Guides/MIME_types/Common_types
function audioToMime(filename: string) {
    const lcextension = filename.toLocaleLowerCase().split('/').slice(-1)[0]?.split('.').slice(-1)[0]
    switch (lcextension) {
        case 'aac':
            return 'audio/aac'
        case 'mid':
        case 'midi':
            return 'audio/midi'
        case 'wav':
            return 'audio/wav'
        case 'oga':
        case 'opus':
        case 'ogg':
            return 'audio/ogg'
        case 'weba':
            return 'audio/webm'
        case '3gp':
            return 'audio/3gpp'
        case '3g2':
            return 'audio/3gpp2'
    }

    return 'audio/mpeg'
}

export const embedMappings: Partial<Record<SupportedAudioEmbedTypes, EmbedMeta>> = {
    megaphone: {
        buildSource: ({ audioId }) => ({
            src: `https://player.megaphone.fm/${audioId}?`,
        }),
        iframeProps: {
            height: 150,
        },
    },

    spotify: {
        buildSource: ({ audioId }) => ({ src: `https://open.spotify.com/embed/track/${audioId}?utm_source=generator&theme=0` }),
        iframeProps: {
            className: 'rounded-xl',
            height: 152,
            allow: 'autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture',
        },
    },
    soundcloud: {
        buildSource: ({ audioId }) => ({
            src: `https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/${audioId}&amp;auto_play=false&amp;hide_related=false&amp;show_artwork=true`,
        }),
        iframeProps: {
            height: 150,
        },
    },
    'soundcloud-playlist': {
        buildSource: ({ audioId }) => ({
            src: `https://theinventory.com/embed/inset/iframe?id=soundcloud-playlist-${audioId}`,
        }),
        iframeProps: {
            height: 150,
        },
    },
    'audio-url': {
        buildSource: ({ audioId }) => ({
            srcDoc: `
            <html lang="en">
                <head>
                    <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
                    <meta name="ROBOTS" content="NOINDEX, NOFOLLOW">
                    <base target="_blank">
                    <style>
                        body, html {
                            margin: 0;
                            padding: 0;
                            min-height: 10px;
                            height: 100%;
                        }

                        body {
                            display: flex;
                            justify-content: center;
                            align-items: center;
                        }

                        iframe {
                            width: 100%;
                            height: 100%;
                        }

                        audio {
                            border-radius: 12px;
                            width: 100%;
                        }
                    </style>
                </head>
                <body>
                    <audio controls>
                        <source src="${audioId}" type="${audioToMime(audioId)}">
                        Your browser does not support the audio element.
                    </audio>
                </body>
            </html>
            `,
        }),
        iframeProps: {
            height: 60,
        },
    },
}
